(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(x) {
    var v = (Math.round(x * 100) / 100).toFixed(2);
    return '£' + v;
  }

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .1 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* duplicate marquee tracks */
  document.querySelectorAll('[data-marquee]').forEach(function (t) { t.innerHTML += t.innerHTML; });

  /* ── MENU DRAWER ── */
  var drawerEl = document.getElementById('ovDrawer');
  window.drawerToggle = function (force) {
    if (!drawerEl) return;
    var open = typeof force === 'boolean' ? force : !document.body.classList.contains('drawer-open');
    document.body.classList.toggle('drawer-open', open);
    drawerEl.setAttribute('aria-hidden', open ? 'false' : 'true');
    var b = document.getElementById('ovBurger');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.drawerToggle(false); });

  /* lazy-load autoplay videos only when near the viewport */
  var lazyVids = document.querySelectorAll('video[data-src]');
  if (lazyVids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var vv = e.target;
        if (e.isIntersecting) {
          if (!vv.getAttribute('src') && vv.dataset.src) vv.src = vv.dataset.src;
          if (!reduced) vv.play().catch(function () {});
        } else if (!vv.paused) { vv.pause(); }
      });
    }, { rootMargin: '200px' });
    lazyVids.forEach(function (vv) { vio.observe(vv); });
  } else {
    lazyVids.forEach(function (vv) { vv.src = vv.dataset.src; });
  }

  /* cart: quantity change updates the order without the extra button */
  var cartForm = document.getElementById('cartForm');
  if (cartForm) {
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (inp) {
      inp.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ── HERO goal picker + auto-rotate ── */
  var heroDataEl = document.getElementById('hero-data');
  if (heroDataEl) {
    var heroData = JSON.parse(heroDataEl.textContent);
    var heroKeys = ['hsn', 'ash', 'multi', 'sleep', 'acv'];
    var heroIdx = 0;
    var heroTimer = null;

    function applyHero(key, el) {
      var d = heroData[key];
      if (!d) return;
      document.querySelectorAll('.gpill').forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-pressed', 'false'); });
      if (el) { el.classList.add('on'); el.setAttribute('aria-pressed', 'true'); }
      var w = document.getElementById('heroWord');
      if (w) { w.textContent = d.word; w.style.color = d.color; }
      var sub = document.getElementById('heroSub');
      if (sub) sub.textContent = d.sub;
      var cta = document.getElementById('heroCta');
      if (cta) {
        cta.innerHTML = d.cta + ' <span class="arr">＋</span>';
        cta.style.background = d.color;
        cta.style.boxShadow = '0 10px 24px -4px ' + d.color;
        cta.setAttribute('href', d.url);
      }
      var blob = document.getElementById('heroBlob');
      if (blob) blob.style.setProperty('--c', d.blob);
      var r = document.getElementById('heroRate'); if (r) r.textContent = d.rate;
      var dd = document.getElementById('heroDay'); if (dd) dd.textContent = d.day;
      var img = document.getElementById('heroBottle');
      if (img) {
        if (reduced) { img.src = d.img; return; }
        img.classList.add('swap');
        setTimeout(function () { img.src = d.img; img.classList.remove('swap'); }, 160);
      }
    }

    var heroSpins = 0;
    function stopHero() { if (heroTimer) { clearInterval(heroTimer); heroTimer = null; } }
    window.heroPick = function (key, el) {
      heroSpins = 9999;
      stopHero();
      heroIdx = heroKeys.indexOf(key);
      applyHero(key, el);
    };

    /* auto-rotate every 2s: pauses off-screen, stops after 2 laps, on CTA hover or user pick */
    if (!reduced) {
      var pills = document.querySelectorAll('.gpill');
      var heroPanel = document.querySelector('.hero-panel');
      function startHero() {
        if (heroTimer || heroSpins >= heroKeys.length * 2) return;
        heroTimer = setInterval(function () {
          heroSpins++;
          if (heroSpins >= heroKeys.length * 2) { stopHero(); return; }
          heroIdx = (heroIdx + 1) % heroKeys.length;
          applyHero(heroKeys[heroIdx], pills[heroIdx]);
        }, 2000);
      }
      window.addEventListener('load', function () {
        heroKeys.forEach(function (k) { var im = new Image(); im.src = heroData[k].img; });
      });
      var heroCtaEl = document.getElementById('heroCta');
      if (heroCtaEl) { heroCtaEl.addEventListener('pointerenter', stopHero); heroCtaEl.addEventListener('focusin', stopHero); }
      if (heroPanel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) startHero(); else stopHero();
        }, { threshold: .2 }).observe(heroPanel);
      }
      startHero();
    }
  }

  /* ── ROUTINE BUILDER ── */
  var bGrid = document.getElementById('builderGrid');
  if (bGrid) {
    window.bToggle = function (el) { el.classList.toggle('sel'); bRefresh(); };
    function bRefresh() {
      var sel = bGrid.querySelectorAll('.bitem.sel');
      var n = sel.length, sum = 0;
      sel.forEach(function (s) { sum += parseFloat(s.dataset.price); });
      var disc = n >= 3 ? .25 : n >= 2 ? .15 : 0;
      var total = sum * (1 - disc);
      document.getElementById('bbFill').style.width = (n >= 3 ? 100 : n >= 2 ? 66 : n >= 1 ? 33 : 0) + '%';
      var msg = document.getElementById('bbMsg');
      if (n === 0) msg.innerHTML = 'Pick your first bottle to start';
      else if (n === 1) msg.innerHTML = 'Nice start — add 1 more to unlock <em>15% off</em>';
      else if (n === 2) msg.innerHTML = '<em>15% off unlocked!</em> Add a 3rd bottle for <em>25% off</em>';
      else msg.innerHTML = '<em>25% off unlocked</em> — maximum savings, well played 👏';
      document.getElementById('bbTot').textContent = n ? money(total) : '£0.00';
      document.getElementById('bbWas').textContent = disc > 0 ? money(sum) : '';
      document.getElementById('bbSav').textContent = disc > 0 ? 'You save ' + money(sum - total) + ' (' + (disc * 100) + '%)' : 'Discount unlocks at 2 bottles';
      var btn = document.getElementById('bbBtn');
      btn.querySelector('.bb-label').textContent = n ? ('Add ' + n + (n === 1 ? ' bottle' : ' bottles') + ' to cart — ' + money(total)) : 'Add routine to cart';
    }
    window.bAddToCart = function () {
      var sel = bGrid.querySelectorAll('.bitem.sel');
      if (!sel.length) return;
      var btn = document.getElementById('bbBtn');
      if (btn.disabled) return;
      btn.disabled = true;
      var items = [];
      sel.forEach(function (s) { items.push({ id: parseInt(s.dataset.variant, 10), quantity: 1 }); });
      btn.querySelector('.bb-label').textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        window.location.href = window.OV.cartUrl;
      }).catch(function (err) {
        btn.disabled = false;
        btn.querySelector('.bb-label').textContent = 'Try again';
        var m = document.getElementById('bbMsg');
        if (m) m.innerHTML = '⚠️ ' + (err.message || 'Something went wrong — please try again.');
      });
    };
    bRefresh();
  }

  /* ── QUIZ ── */
  var quizEl = document.getElementById('quizBox');
  if (quizEl) {
    var qProducts = JSON.parse(document.getElementById('quiz-data').textContent);
    var quizData = {
      q1: { q: 'What’s your №1 goal right now?', opts: [
        ['⚡ More daily energy', 'multi'], ['✨ Hair, skin & nails', 'hsn'],
        ['🧘 Less stress, more calm', 'ash'], ['😴 Better sleep', 'sleep'], ['🍎 Metabolism support', 'acv'] ] },
      q2: { q: 'How do you feel about routines?', opts: [
        ['I forget things — make it automatic', 'sub'], ['I’m consistent — one-time is fine', 'once'], ['Go big — I want the full routine', 'kit'] ] }
    };
    var qStep = 1, qGoal = null;
    function renderQuiz() {
      var d = qStep === 1 ? quizData.q1 : quizData.q2;
      document.getElementById('quizProg').textContent = 'Question ' + qStep + ' of 2';
      document.getElementById('quizQ').textContent = d.q;
      var box = document.getElementById('quizOpts'); box.innerHTML = '';
      d.opts.forEach(function (o) {
        var b = document.createElement('button');
        b.className = 'quiz-opt'; b.type = 'button'; b.textContent = o[0];
        b.onclick = function () { quizPick(o[1]); };
        box.appendChild(b);
      });
    }
    function quizPick(val) {
      if (qStep === 1) { qGoal = val; qStep = 2; renderQuiz(); return; }
      var p = qProducts[qGoal];
      var suffix = val === 'sub' ? ' — on Subscribe & Save (−20%)' : '';
      if (val === 'kit' && qProducts.kit) { p = qProducts.kit; suffix = ' — the full routine, −27%'; }
      document.getElementById('quizStep').style.display = 'none';
      document.getElementById('quizRes').style.display = 'flex';
      document.getElementById('quizImg').src = p.img;
      document.getElementById('quizTitle').textContent = p.name + suffix;
      document.getElementById('quizWhy').textContent = p.why;
      var link = document.getElementById('quizGo');
      link.setAttribute('href', p.url);
    }
    window.quizReset = function () {
      qStep = 1; qGoal = null;
      document.getElementById('quizStep').style.display = 'block';
      document.getElementById('quizRes').style.display = 'none';
      renderQuiz();
    };
    renderQuiz();
  }

  /* ── PDP ── */
  var pdp = document.getElementById('pdpRoot');
  if (pdp) {
    var oneTime = parseFloat(pdp.dataset.price);
    var subPrice = parseFloat(pdp.dataset.subPrice || 0);
    var hasSub = !!subPrice;
    var avail = pdp.dataset.available !== 'false';

    var track = document.getElementById('pdpTrack');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs button'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('#pdpDots span'));
    var gn = track ? track.children.length : 0;
    var gi = 0;
    function galMark(i) {
      gi = i;
      thumbs.forEach(function (b, j) { b.classList.toggle('on', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    }
    window.galTo = function (i) {
      if (!track || gn < 2) return;
      i = ((i % gn) + gn) % gn;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      galMark(i);
    };
    window.galStep = function (d) { window.galTo(gi + d); };
    if (track) {
      var galT;
      track.addEventListener('scroll', function () {
        clearTimeout(galT);
        galT = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== gi && i >= 0 && i < gn) galMark(i);
        }, 60);
      }, { passive: true });
    }

    var subMode = hasSub;
    var optSub = document.getElementById('optSub');
    var optOnce = document.getElementById('optOnce');
    var planInput = document.getElementById('sellingPlanInput');
    var freqSel = document.getElementById('freqSel');
    function unit() { return subMode ? subPrice : oneTime; }
    function qty() { return parseInt(document.getElementById('pdpQty').value, 10) || 1; }
    function refreshPrice() {
      if (!avail) return;
      var q = qty();
      var f = (!subMode && q >= 3) ? 0.75 : (!subMode && q >= 2) ? 0.85 : 1;
      var t = unit() * q * f;
      var label = 'Add to cart — ' + money(t) + (subMode ? '/mo' : '');
      document.getElementById('atcLabel').textContent = label;
      var note = document.getElementById('tierNote');
      if (note) note.textContent = f < 1 ? '✓ ' + (f === 0.75 ? '25%' : '15%') + ' multi-bottle discount applies automatically at checkout' : '';
      var sp = document.getElementById('stickyPrice');
      if (sp) sp.textContent = money(t) + (subMode ? '/mo' : '');
    }
    window.setMode = function (sub) {
      if (!hasSub) sub = false;
      subMode = sub;
      if (optSub) { optSub.classList.toggle('on', sub); optSub.setAttribute('aria-checked', sub ? 'true' : 'false'); }
      if (optOnce) { optOnce.classList.toggle('on', !sub); optOnce.setAttribute('aria-checked', sub ? 'false' : 'true'); }
      if (planInput) planInput.value = sub && freqSel ? freqSel.value : '';
      var tiersEl = document.querySelector('.tiers');
      if (tiersEl) {
        tiersEl.style.display = sub ? 'none' : '';
        if (sub) {
          document.getElementById('pdpQty').value = 1;
          document.querySelectorAll('.tier').forEach(function (t, j) {
            t.classList.toggle('on', j === 0);
            t.setAttribute('aria-checked', j === 0 ? 'true' : 'false');
          });
        }
      }
      refreshPrice();
    };
    if (optSub) optSub.addEventListener('click', function () { window.setMode(true); });
    if (optOnce) optOnce.addEventListener('click', function () { window.setMode(false); });
    [optSub, optOnce].forEach(function (o) {
      if (!o) return;
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); window.setMode(o === optSub); }
      });
    });
    if (freqSel) freqSel.addEventListener('change', function () { if (subMode && planInput) planInput.value = this.value; });
    window.pickTier = function (el, n) {
      document.querySelectorAll('.tier').forEach(function (t) { t.classList.remove('on'); t.setAttribute('aria-checked', 'false'); });
      el.classList.add('on');
      el.setAttribute('aria-checked', 'true');
      document.getElementById('pdpQty').value = n;
      refreshPrice();
    };
    window.setMode(hasSub);

    function cutoff() {
      var el = document.getElementById('cutoff');
      if (!el) return;
      var row = el.closest('.urgency');
      var uk;
      try { uk = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' })); }
      catch (e) { uk = new Date(); }
      var day = uk.getDay();
      if (day === 0 || day === 6) { if (row) row.innerHTML = '📦 Ordered this weekend? Dispatched Monday morning.'; return; }
      var c = new Date(uk); c.setHours(14, 0, 0, 0);
      if (c <= uk) { if (row) row.innerHTML = '📦 Order now — dispatched ' + (day === 5 ? 'Monday' : 'tomorrow') + ' morning.'; return; }
      var mins = Math.floor((c - uk) / 60000);
      el.textContent = Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
    }
    cutoff(); setInterval(cutoff, 30000);

    var sticky = document.getElementById('stickyAtc');
    var mainBtn = document.getElementById('atcBtn');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        sticky.classList.toggle('show', !es[0].isIntersecting);
      }, { rootMargin: '-70px 0px 0px 0px' }).observe(mainBtn);
      var sBtn = document.getElementById('stickyBtn');
      if (sBtn) sBtn.addEventListener('click', function () { if (mainBtn.disabled) return; mainBtn.click(); });
    }
  }
})();
